@if (consentGroups().length > 0) {
  <div class="flyout-row">
    <div class="flyout-data-group">
      <mat-expansion-panel [expanded]="true" class="mat-elevation-z0">
        <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
          <img class="header-icon" src="/assets/img/icons_fl/consent.svg" width="32px" height="32px" />
          <span>{{ "flyout.general.consents" | translate }}</span>
        </mat-expansion-panel-header>

        @for (group of consentGroups(); track group.key) {
          <div class="expansion-panel-row values">
            <div class="value consent-value">
              @if (group.versionDate || group.revisionNumber) {
                <div class="consent-group-header">
                  @if (group.privacyPolicyUrl) {
                    <a [href]="group.privacyPolicyUrl" target="_blank" rel="noopener" [title]="group.privacyPolicyUrl">
                      @if (group.versionDate) {
                        <span>{{ "generic.version" | translate }}: {{ group.versionDate | formatDate }}</span>
                      }
                      @if (group.revisionNumber) {
                        <span>{{ group.versionDate ? ", " : "" }}{{ "generic.revision" | translate }}: {{ group.revisionNumber }}</span>
                      }
                      <mat-icon>open_in_new</mat-icon>
                    </a>
                  } @else {
                    @if (group.versionDate) {
                      <span>{{ "generic.version" | translate }}: {{ group.versionDate | formatDate }}</span>
                    }
                    @if (group.revisionNumber) {
                      <span>{{ group.versionDate ? ", " : "" }}{{ "generic.revision" | translate }}: {{ group.revisionNumber }}</span>
                    }
                  }
                </div>
              }
              @for (entry of group.entries; track entry.labelKey) {
                <div class="consent-entry">
                  <div>
                    <strong>{{ entry.labelKey | translate }}</strong>
                    <span class="consent-count">{{ entry.countKey | translate: entry.countParams }}</span>
                  </div>
                  <div class="consent-occurrence">
                    {{ "data-platform.consent-latest" | translate }}: {{ entry.latestDate | formatDate }}{{ entry.latest.title ? "," : "" }}
                    @if (entry.latest.title) {
                      <span>"{{ entry.latest.title }}"</span>
                    }
                  </div>
                  @if (entry.showDetails) {
                    @if (entry.latest.privacyPolicyText) {
                      <div class="consent-text">{{ entry.latest.privacyPolicyText }}</div>
                    }
                    @if (entry.latest.currentUrl) {
                      <div class="consent-url">
                        <a [href]="entry.latest.currentUrl" target="_blank" rel="noopener" [title]="entry.latest.currentUrl">{{ entry.latest.currentUrl }}</a>
                      </div>
                    }
                    @if (entry.latest.isCheckboxPresent != null) {
                      <div>
                        {{ "data-platform.consent-checkbox" | translate }}:
                        {{ (entry.latest.isCheckboxPresent ? "generic.yes" : "generic.no") | translate }}
                      </div>
                    }
                  }
                  @if (entry.first) {
                    <div class="consent-occurrence">
                      {{ "data-platform.consent-first" | translate }}: {{ entry.firstDate | formatDate }}{{ entry.first.title ? "," : "" }}
                      @if (entry.first.title) {
                        <span>"{{ entry.first.title }}"</span>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </mat-expansion-panel>
    </div>
  </div>
}
